/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface CompleteMilestoneResponseContent
 */
export interface CompleteMilestoneResponseContent {
    /**
     * Percentage used for grading and milestone weights.
     * @type {number}
     * @memberof CompleteMilestoneResponseContent
     */
    updatedCumulativePercentage: number;
    /**
     * Identifier of a milestone within the catalog task entry.
     * @type {string}
     * @memberof CompleteMilestoneResponseContent
     */
    nextMilestoneId?: string;
    /**
     * Human-readable title for a milestone.
     * @type {string}
     * @memberof CompleteMilestoneResponseContent
     */
    nextMilestoneName?: string;
    /**
     * Percentage used for grading and milestone weights.
     * @type {number}
     * @memberof CompleteMilestoneResponseContent
     */
    nextMilestonePercentageContribution?: number;
}


/**
 * Check if a given object implements the CompleteMilestoneResponseContent interface.
 */
export function instanceOfCompleteMilestoneResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "updatedCumulativePercentage" in value;
    return isInstance;
}

export function CompleteMilestoneResponseContentFromJSON(json: any): CompleteMilestoneResponseContent {
    return CompleteMilestoneResponseContentFromJSONTyped(json, false);
}

export function CompleteMilestoneResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteMilestoneResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'updatedCumulativePercentage': json['updatedCumulativePercentage'],
        'nextMilestoneId': !exists(json, 'nextMilestoneId') ? undefined : json['nextMilestoneId'],
        'nextMilestoneName': !exists(json, 'nextMilestoneName') ? undefined : json['nextMilestoneName'],
        'nextMilestonePercentageContribution': !exists(json, 'nextMilestonePercentageContribution') ? undefined : json['nextMilestonePercentageContribution'],
    };
}

export function CompleteMilestoneResponseContentToJSON(value?: CompleteMilestoneResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'updatedCumulativePercentage': value.updatedCumulativePercentage,
        'nextMilestoneId': value.nextMilestoneId,
        'nextMilestoneName': value.nextMilestoneName,
        'nextMilestonePercentageContribution': value.nextMilestonePercentageContribution,
    };
}

